import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { Promocao } from 'pages/financeiro/reembolso/gerar-reembolso/types';

export function GerarReembolsoPromocaoAutoComplete({
    sx,
    name,
    value,
    error,
    options,
    readOnly,
    disableClearable,
    multiple = false,
    disabled = false,
    onChange = () => {},
    size = 'medium',
    requestOptions = {
        url: '/financeiro/promocao/reembolso/periodo',
        sort: [{ property: 'idPromocao', direction: 'ASC' }],
        limit: 50,
    },
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            size={size}
            value={value}
            error={error}
            options={options}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            requestOptions={requestOptions}
            disableClearable={disableClearable}
            objectId="idPromocao"
            label={'Campanha/promoção'}
            optionStringTemplate="{dsPromocao}"
            selectedStringTemplate="{dsPromocao}"
            isOptionEqualToValue={(option: Promocao, value: Promocao) => value && option && option.idPromocao === value.idPromocao}
        />
    );
}
